<template>
  <div>
    <h3>Liste des membres</h3>
    <p class="explication" v-if="!userInfos.subscription || userInfos.subscription.type === 'individuel'">
      Si vous désirez ajouter un autre membre de votre famille, vous devez choisir l'adhésion familiale. Veuillez nous contacter pour faire le
      changement.
    </p>

    <table class="table">
      <thead>
      <tr>
        <th>Prénom</th>
        <th>Nom</th>
        <th>Courriel</th>
        <th style="width: 132px;">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="member in members" :key="member.id">
        <td>{{ member.firstName }}</td>
        <td>{{ member.lastName }}</td>
        <td>{{ member.email }}</td>
        <td>
          <b-button
              disabled
              size="sm"
              variant="outline-primary"
              v-b-tooltip.hover title="Modifier le membre"
          >
            <font-awesome-icon icon="pen" size="xs"/>
          </b-button>
          <b-button
              size="sm"
              variant="outline-primary"
              @click="openMemberCard(member)"
              v-b-tooltip.hover title="Visualiser la carte de membre"
              style="margin-left: 5px;"
          >
            <font-awesome-icon icon="id-card" size="xs"/>
          </b-button>
          <b-button
              disabled
              size="sm"
              variant="outline-danger"
              style="margin-left: 5px;"
              v-b-tooltip.hover title="Supprimer le membre"
              v-if="!member.main"
          >
            <font-awesome-icon icon="trash" size="xs"/>
          </b-button>
        </td>
      </tr>
      </tbody>
    </table>

    <div style="width: 100%; text-align: right">
      <b-button
          disabled
          variant="primary"
          v-if="userInfos && userInfos.subscription && userInfos.subscription.subscriptionType.allowMultipleMembers === true"
      >
        Ajouter un membre
      </b-button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import MemberAddOrEditV2 from './Membre_AjoutModifier';
  import _ from 'lodash';
  import config from '../../config';

  export default {
    name: 'MembersList',
    data() {
      return {
        showEditModal: false,
        memberToEdit: null
      };
    },
    mounted() {
      this.fetchMembers();
    },
    computed: {
      ...mapState({
        userInfos: state => state.account.user.infos,
        _members: state => state.members.members
      }),
      members() {
        if (this.userInfos.subscription && this.userInfos.subscription.subscriptionType && this.userInfos.subscription.subscriptionType.allowMultipleMembers === false) {
          if (_.size(this._members) === 1) {
            return this._members;
          }
          const mm = _.filter(this._members, m => m.main === true);
          if (_.size(mm) === 0) {
            return _.first(this._members);
          }
          return mm;
        }
        return this._members;
      }
    },
    watch: {
      showEditModal(to, from) {
        setTimeout(() => {
          try {
            if (from !== true && to === true) {
              this.$refs['add-or-edit-member-modal'].$refs['modal'].open();
            }
            else if (to === false) {
              this.$refs['add-or-edit-member-modal'].$refs['modal'].close();
            }
          }
          catch (e) {
          // hide
          }
        }, 200);
      }
    },
    methods: {
      ...mapActions('members', {
        fetchMembers: 'fetchMembers',
        deleteMember: 'delete'
      }),
      addMember() {
        this.$modal.show(
          MemberAddOrEditV2,
          {
            member: {
              firstName: '',
              lastName: '',
              newsletter: true
            }
          },
          {
            height: 'auto',
            width: '800px',
            name: 'add-edit-member',
            root: this.$root
          }
        );
      },
      editMember(member) {
        this.$modal.show(
          MemberAddOrEditV2,
          { member },
          {
            height: 'auto',
            width: '800px',
            name: 'member-add-edit-modal',
            root: this.$root
          }
        );
      },
      upsertMember(memberData) {
        if (!this.memberToEdit) {
          this.members.push(memberData);
        }
        this.showEditModal = false;
        this.memberToEdit = null;
      },
      async removeMember(member) {
        // Ask confirmation
        const info = await this.$swal.fire({
          title: 'Confirmation',
          text:
            'Êtes-vous certain(e) de vouloir retirer ce membre? Cette opération n\'est pas réversible.',
          type: 'warning',
          showConfirmButton: true,
          confirmButtonText: 'Oui',
          showCancelButton: true,
          cancelButtonText: 'Non'
        });

        if (info.value === true) {
          try {
            this.deleteMember({ id: member.id });
            this.$swal.fire({
              text: 'Le membre a été supprimé',
              type: 'success',
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            });
          }
          catch (e) {
            console.error('Failed to delete member', e);
            this.$swal.fire({
              title: 'Erreur',
              text: 'Une erreur s\'est produite lors de la suppression du membre.',
              type: 'error'
            });
          }
        }
      },
      openMemberCard(member) {
        window.open(
          `${config.apiUrl}/members/${member.id}/card?token=`,
          '_blank'
        );
      }
    }
  };
</script>

<style scoped lang="scss">
.explication {
  margin-bottom: 10px;
  margin-top: 10px;
  text-align: center;
  color: dimgray;
}
</style>
